
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_p8a6i_1ma2v_9",
  "header": "awsui_header_p8a6i_1ma2v_41",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_1ma2v_41",
  "header-refresh": "awsui_header-refresh_p8a6i_1ma2v_44",
  "list": "awsui_list_p8a6i_1ma2v_51",
  "list-grid-1": "awsui_list-grid-1_p8a6i_1ma2v_62",
  "card": "awsui_card_p8a6i_1ma2v_62",
  "list-grid-2": "awsui_list-grid-2_p8a6i_1ma2v_65",
  "list-grid-3": "awsui_list-grid-3_p8a6i_1ma2v_68",
  "list-grid-4": "awsui_list-grid-4_p8a6i_1ma2v_71",
  "list-grid-5": "awsui_list-grid-5_p8a6i_1ma2v_74",
  "list-grid-6": "awsui_list-grid-6_p8a6i_1ma2v_77",
  "list-grid-7": "awsui_list-grid-7_p8a6i_1ma2v_80",
  "list-grid-8": "awsui_list-grid-8_p8a6i_1ma2v_83",
  "list-grid-9": "awsui_list-grid-9_p8a6i_1ma2v_86",
  "list-grid-10": "awsui_list-grid-10_p8a6i_1ma2v_89",
  "list-grid-11": "awsui_list-grid-11_p8a6i_1ma2v_92",
  "list-grid-12": "awsui_list-grid-12_p8a6i_1ma2v_95",
  "list-grid-13": "awsui_list-grid-13_p8a6i_1ma2v_98",
  "list-grid-14": "awsui_list-grid-14_p8a6i_1ma2v_101",
  "list-grid-15": "awsui_list-grid-15_p8a6i_1ma2v_104",
  "list-grid-16": "awsui_list-grid-16_p8a6i_1ma2v_107",
  "list-grid-17": "awsui_list-grid-17_p8a6i_1ma2v_110",
  "list-grid-18": "awsui_list-grid-18_p8a6i_1ma2v_113",
  "list-grid-19": "awsui_list-grid-19_p8a6i_1ma2v_116",
  "list-grid-20": "awsui_list-grid-20_p8a6i_1ma2v_119",
  "selection-control": "awsui_selection-control_p8a6i_1ma2v_123",
  "loading": "awsui_loading_p8a6i_1ma2v_133",
  "empty": "awsui_empty_p8a6i_1ma2v_134",
  "has-header": "awsui_has-header_p8a6i_1ma2v_141",
  "refresh": "awsui_refresh_p8a6i_1ma2v_144",
  "card-header": "awsui_card-header_p8a6i_1ma2v_160",
  "card-header-inner": "awsui_card-header-inner_p8a6i_1ma2v_169",
  "card-header-inner-selectable": "awsui_card-header-inner-selectable_p8a6i_1ma2v_172",
  "card-selected": "awsui_card-selected_p8a6i_1ma2v_175",
  "section": "awsui_section_p8a6i_1ma2v_179",
  "section-header": "awsui_section-header_p8a6i_1ma2v_186",
  "section-content": "awsui_section-content_p8a6i_1ma2v_192",
  "footer-pagination": "awsui_footer-pagination_p8a6i_1ma2v_204"
};
  